import {
  SET_DEVICE_TYPE,
  INIT_APP,
  AUTH_FIELD_CHANGED,
  REGISTER_USER,
  REGISTER_USER_FAIL,
  REGISTER_USER_SUCCESS,
  AUTH_UNLOAD,
  TOGGLE_COPY,
  GET_TEAM_INFO,
  GET_TEAM_INFO_FAIL,
  GET_TEAM_INFO_SUCCESS,
  LOGIN_USER,
  LOGIN_USER_FAIL,
  LOGIN_USER_SUCCESS
} from '../actions/types';

const INITIAL_STATE = {
  device_type: "desktop",
  init: false,
  signup_type: '',
  signup_team_name: '',
  signup_team_company: '',
  email: '',
  password: '',
  firstname: '',
  lastname: '',
  company: '',
  error: '',
  loading: false,
  user: null,
  token: '',
  actionSheet: null,
  onboarding: false,
  from_campaign: '',
  from_source: '',
  branch_id: '',
  copy_tab: "how_it_works",
  team_loading:false,
  team_error: '',
  team:null,
  partner: '',
  partner_logo: '',
  partner_logo_white: '',
}

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case SET_DEVICE_TYPE:
      return {
        ...state,
        device_type: action.payload
      }
    case INIT_APP:
      return {
        ...state,
        init: action.payload
      };
    case AUTH_FIELD_CHANGED:
      //action.payload === {prop: 'name', value: 'Jane'}
      return {
        ...state,
        [action.payload.prop]: action.payload.value
      };
    



    case REGISTER_USER:
      return {
        ...state,
        error: '',
        loading: true
      }

    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        ...INITIAL_STATE,
        user: action.payload.user,
        token: action.payload.token
      };

    case REGISTER_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        password: '',
        loading: false
      };

    case AUTH_UNLOAD:
      return {
        ...state,
        ...INITIAL_STATE,
        init: true
      };

      case TOGGLE_COPY:
        return{
          ...state,
          copy_tab: action.payload
        }
      case GET_TEAM_INFO:
        return{
          ...state,
          team: null,
          team_loading: true,
          team_error: ''
        };
      case GET_TEAM_INFO_FAIL:
        return{
          ...state,
          team_loading: false,
          team_error: action.payload
        };
      case GET_TEAM_INFO_SUCCESS:
        return{
          ...state,
          team_loading: false,
          team: action.payload.team
        };
      case LOGIN_USER:
        return {
          ...state,
          error: '',
          loading: true
        }

      case LOGIN_USER_SUCCESS:
        return {
          ...state,
          ...INITIAL_STATE,
          init: true,
          user: action.payload.user,
          token: action.payload.token
        };

      case LOGIN_USER_FAIL:
        return {
          ...state,
          error: action.payload,
          password: '',
          loading: false
        };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js